// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_35Pqd","visuallyhidden":"_127bn","hide-text":"_-GxqS","center":"oiopZ","noprint":"_3-BIM","listItem":"_33DTW","authorList":"_JeFb","image":"_1WY8s"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-byline/styles/Byline.scss
 ** module id = 938
 ** module chunks = 1
 **/